import { PropsWithChildren, useRef } from 'react';

import isPropValid from '@emotion/is-prop-valid';
import ToastQueue from '@src/components/Toast/ToastQueue';
import { themeStyle, useNewThemeActive } from '@src/theming';
import GlobalStyle from '@src/theming/globalStyle';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import UIRootContext from './context';
import { ModalWrapper, Wrapper } from './styles';
import useInit from './useInit';

export const UIRootWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  useInit();
  const rootContainer = useRef<HTMLDivElement | null>(null);
  const isNewThemeActive = useNewThemeActive();
  const modalContainer = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <GlobalStyle
        key={`${isNewThemeActive}`}
        isNewThemeActive={isNewThemeActive}
      />
      <UIRootContext.Provider
        value={{
          getRootContainer: () => rootContainer.current ?? null,
          getModalContainer: () => modalContainer.current ?? null,
        }}
      >
        <StyleSheetManager
          key={`${isNewThemeActive}`}
          shouldForwardProp={isPropValid}
        >
          <ThemeProvider theme={themeStyle}>
            <Wrapper ref={rootContainer}>{children}</Wrapper>
            <ModalWrapper ref={modalContainer} />
          </ThemeProvider>
        </StyleSheetManager>
      </UIRootContext.Provider>
      <ToastQueue />
    </>
  );
};
